import { createRouter, createWebHistory } from 'vue-router';
import NotFound from '@/views/NotFound.vue';
import ConfiguratorRoutes from './Configurator';
import Checkout from '../views/Checkout';
import MyVespaDetails from "../views/MyVespaDetails";

const routes = [
    ...ConfiguratorRoutes,
    {
        path: "/checkout/:step?",
        name: "Checkout",
        component: Checkout,
        meta: {
            hideTopMenu: true,
            hideFooter: true
        }
    },
    {
        path: "/order/:orderNumber?",
        name: "MyVespaDetails",
        component: MyVespaDetails,
        meta: {
            hideTopMenu: true,
            hideFooter: true
        }
    },
    {
        path: "/:catchAll(.*)",
        name: "NotFound",
        component: NotFound,
    }
];

export default createRouter({
    history: createWebHistory(),
    routes,
});
